<template>
    <div class="history-list m-auto" data-cy="list_history_list">
        <HistoryItem
            v-for="(campaign) of purchases"
            :key="campaign.id"
            :purchase="campaign"
            @onClickPurchase="clickPurchase(campaign)"
            :data-cy="`card_history_list_item_${campaign.id}`"
        ></HistoryItem>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/Locale.js';
import ConfigManager from '@/config/ConfigManager.js';
import { CampaignType } from '@/helper/StaticValue.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
import CampaignUseMixin from "@/mixin/CampaignUseMixin.js";
//component
import HistoryItem from './HistoryItem.vue';
//service
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js'; 

export default {
    name: 'HistoryList',
    components: {
        HistoryItem,
    },
    props: {
        listConfig: { type: Object, required: true },
        filterConfig: { type: Object, required: true },
        modalController: { type: Object, required: true },
    },
    mixins: [LocaleMixin, CampaignUseMixin],
    data: function () {
        return {
            purchases: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,

            isSerialLoading: false,
        };
    },
    methods: {
        //#region history list
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsHistory.apiGetPurchase(this.listConfig, this.filterConfig).subscribe((purchases) => {
                    // Util.log('history list', purchases);

                    this.listConfig.increstSkip();
                    //check is there are more campaign.
                    if (purchases && purchases.length < this.listConfig.defaultTopAmount) {
                        this.listConfig.setSeeMoreEnable(false);
                    }
                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                        this.purchases = [];
                    }

                    for (var purchase of purchases) {
                        //TODO: Add GA Tracking.
                        this.purchases.push(purchase);
                    }

                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.purchases.length > 0 ? true : false;
                    resolve();
                }, (err) => {
                    resolve();
                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.errorApi(err);
                });
            });
        },

        loadMore: function () {
            if (!this.listConfig.isSeeMoreEnable) {
                return;
            }

            if (this.isLoading) {
                return;
            }
            this.getList();
        },
        //#endregion history list

        //#region action history
        clickPurchase: function (purchase) {
            //check internet stuff.
            if (this.isSerialLoading) {
                return;
            }

            // this.clickedIndex = index;

            if (purchase.type === CampaignType.Interface) {
                this.openInterfaceHistory(purchase);
                return;
            }

            if (this.isShowSerialModal(purchase)) { 
                this.openSerial(purchase);
            }
        },

        openSerial: function (purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            //console.log('open serial', purchase);
            this.modalController.serialModal
                .clearModal()
                .setSerial(serialModel)
                .show();
            this.modalController.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.refreshList();
            });
            this.modalController.serialModal.onMarkUsed(() => { 
                this.modalController.serialModal.hide();
                this.showConfirmMarkUsed(purchase);
            });
            
        }, 

        openInterfaceHistory: function (purchase) {
            var sToken = Account.getTokenShuffle();
            var locale = Locale.getLocaleCode();
            var header = 'false';
            var theme = ConfigManager.getAppName();
            var returnUrl = encodeURIComponent(window.location.href);

            // new generation landing interface
            if (purchase.privilegeMessageFormat == 'link') {
                var url = purchase.privilegeMessage;

                url = url.replace('<campaign_id>', purchase.id);
                url = url.replace('<token>', sToken);
                url = url.replace('<serial>', purchase.serial);
                url = url.replace('<locale>', Locale.getLocaleCode());

                url += '&return_url=' + returnUrl;

                window.location.replace(url);
                return;
            }

            // old default landing interface
            if (purchase.website && purchase.website.indexOf('starbucks') > 0) {
                let url = purchase.website +
                    '&token=' + sToken +
                    '&locale=' + locale +
                    '&RedeemKey=' + purchase.redeemKey +
                    '&header=' + header +
                    '&theme=' + theme +
                    '&return_url=' + returnUrl; // ReturnUrl;
                window.location.replace(url);
            } else if (purchase.website && purchase.website.indexOf('linesticker') > 0) {
                let url = purchase.website
                    + "&info2=" + purchase.info2
                    + "&info3=" + purchase.info3
                    + "&locale=" + locale
                    + "&return_url=" + encodeURIComponent(window.location.href)
                    + "&token=" + sToken
                    + "&is_history=true";
                window.location.replace(url);
            }
        },

        isShowSerialModal: function (purchase) {
            if (purchase.serial === 'XXXXXXX') {
                return false;
            }
            if (purchase.expireIn && purchase.expireIn <= 0) {
                return false;
            }

            if (purchase.type === CampaignType.Interface) {
                if (purchase.pointType === "get")
                    return false;

                return true;
            }

            if (purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy) {
                if (purchase.delivered) {
                    return false;
                }
            }

            if (purchase.type === CampaignType.Draw) {
                return false;
            }

            return true;
        },

        refreshList: function () {
            var tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then(() => {
                this.purchases = tmp;
            });
        },
        //#endregion action history 
    },
}
</script>
<style lang="scss" scoped>
.history-list {
    max-width: 500px;
}
</style>
